import Grid from '@material-ui/core/Grid';
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
  Theme,
} from '@material-ui/core';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

import AddCircleIcon from '@material-ui/icons/AddCircle';

import React, { useState } from 'react';

import { baseTheme } from '../../../../theme';

import { IPostActionButton } from '../interfaces';
import { deletePost } from '../../../../services';
import { getPostsAction, setAppLoadingState } from '../../../../store';
import { useDispatch } from 'react-redux';
import { setSelectedPostAction } from '../../../../store/posts/actions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.primary.main,
      paddingBottom: '5px',
      textAlign: 'center',
      '&:hover': {
        paddingBottom: '0',
        borderBottom: 'solid 5px',
        borderColor: theme.palette.primary.main,
      },
    },
    publicColor: {
      color: theme.palette.primary.main,
    },
    privateColor: {
      color: theme.palette.secondary.main,
    },
    staticColor: {
      color: theme.palette.text.primary,
    },
    staticButtonColor: {
      color: theme.palette.text.primary,

      '&:hover': {
        color: theme.palette.text.secondary,
      },
    },
  }),
);

interface IDeleteButtonProps extends IPostActionButton {
  postId: string;
  postTitle: string;
  currUserId: string;
  listConfig: any;
  postType?: string | null;
}

export default function DeletePostButton(props: IDeleteButtonProps) {
  const { postId, postTitle, postType = null, currUserId, listConfig } = props;
  const classes = useStyles(baseTheme);
  const dispatch = useDispatch();
  const [deleteConfirm, setDeleteConfirmation] = useState<boolean>(false);

  const handleDelete = async (event: any) => {
    event.preventDefault();
    setAppLoadingState(dispatch, true);
    await deletePost(postId);
    dispatch(setSelectedPostAction(null));
    getPostsAction(currUserId, listConfig, dispatch);
    setAppLoadingState(dispatch, false);
  };

  const handleClick = (event: any) => {
    event.stopPropagation();
    setDeleteConfirmation(true);
  };

  const handleClose = (event: any) => {
    event.stopPropagation();
    setDeleteConfirmation(false);
  };

  const colorSelector = postType === 'Public'
    ? classes.publicColor
    : postType === 'Private'
      ? classes.privateColor
      : classes.staticColor;

  return props.iconOnly ?
    (<AddCircleIcon onClick={handleClick} />) :
    (
      <Grid
        item
        container
        direction="column"
        xs={1}
        className={`${classes.root} ${colorSelector}`}
        onClick={handleClick}>
        <Grid item>
          <HighlightOffIcon />
        </Grid>
        <Grid item>
          Delete
        </Grid>

        <Dialog
          open={deleteConfirm}
          onClose={handleClose}
        >
          <DialogTitle id="alert-delete-dialog-action">{`Delete ${postTitle}`}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you would like to delete {postTitle}?
            </DialogContentText>
            <DialogActions>
              <Button onClick={handleClose} className={classes.staticButtonColor}>Disagree</Button>
              <Button onClick={handleDelete} className={colorSelector}>Agree</Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </Grid>
    );
}
